import React, { useState, useEffect } from 'react';
import '../css/App.scss';
import HabitInput from './HabitInput';
import HabitList from './HabitList'

function App() {
  const [ habit, setHabit ] = useState({});
  const [ loadedHabits, setLoadedHabits ] = useState(false);

  useEffect(() => {
    const localStorageRef = localStorage.getItem('habits');

    if (localStorageRef) {
      setHabit(JSON.parse(localStorageRef));
    }

    setLoadedHabits(true);

    if (!localStorage.getItem('expiryTime')) {
      updateExpiryDate();
    };
    
  }, []); 

  const updateExpiryDate = () => {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + (((1 + 7 - expiryDate.getDay()) % 7) || 7));
    // Date.setSeconds, .setHours, .setMinutes to set 
    expiryDate.setHours(0);
    expiryDate.setMinutes(0);
    expiryDate.setSeconds(1);

    const expiryTime = expiryDate.getTime();

    localStorage.setItem('expiryTime', expiryTime);
  }

  const isNewWeek = () => {
    const expiryTime = Number(localStorage.getItem('expiryTime'));
    const currentTime = new Date().getTime();

    console.log(currentTime, expiryTime)
    if (currentTime > expiryTime) {
      return true;
    }

    return false;

  }

  const clearHabitDays = () => {
    const habits = {...habit};

    Object.keys(habits).forEach((h) => {
      habits[h].monday = false;
      habits[h].tuesday = false;
      habits[h].wednesday = false;
      habits[h].thursday = false;
      habits[h].friday = false;
      habits[h].saturday = false;
      habits[h].sunday = false;
    })

    setHabit(habits);
  }


  const updateLocalStorage = () => {
    localStorage.setItem('habits', JSON.stringify(habit));
  }

  useEffect(() => {
    if (loadedHabits) {
      updateLocalStorage();

      if (isNewWeek()) { // is new week gets local storage expiry date and compares it against current time
        clearHabitDays(); // sets all days of all habits to false
        updateExpiryDate(); // finds the next monday and uses it to generate a new expiry date, and stores it in local storage
        updateLocalStorage(); // this already is nice 
      }
    }
  }, [habit, loadedHabits]);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Weekly Habit Tracker</h1>
      </header>

      <main>
        <div className="adding-habits">
        <h2>New Habit:</h2>
          <HabitInput setHabit={setHabit} habit={habit} updateLocalStorage={updateLocalStorage} />
        </div>

        <div className="showing-habits">

          <div className="habit-headings">
            <h2>Habits (Mon - Sun):</h2>
          </div>

          <HabitList 
            habit={habit}
            setHabit={setHabit} 
          />
        </div>
      </main>
    </div>
  );
}

export default App;